export default __webpack_public_path__ + "static/media/017-honey.67db3f26.svg";